import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/error.svg';
import { Icon } from '../Icon/Icon';
export const ErrorIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
